import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import Detail from "@/pages/detail/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/newsDetail/page";
import Search from "@/pages/search/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "category/:type",
        element: <Category />,
      },
      {
        path: "detail/:id",
        element: <Detail />,
      },
      {
        path: "news",
        element: <News />,
      },
      {
        path: "news/detail/:id",
        element: <NewsDetail />,
      },
      {
        path: "search",
        element: <Search />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;